import { BasedB2CTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedB2CTransaction/BasedB2CTransactionResponseModel";
import { BasedDetailTransactionResponseModel } from "app/based/baseApiModel/baseTransactionHistory/basedDetailTransaction/BasedDetailTransactionResponseModel";

export class MobiSimRegistrationResponseEntity extends BasedB2CTransactionResponseModel {
  carrier?: string;
  phoneNumber?: string;
  totalPrice?: string | number;
  package?: string;
  packageCode?: string;
  userName?: string;
  userPhone?: string;
  userEmail?: string;
  partnerCode?: string;
  partnerName?: string;
  beforeCredit?: string;
  afterCredit?: string;
  supplierRefCode?: string;
  simType?: string | number;

  constructor(data?: Partial<MobiSimRegistrationResponseEntity>) {
    super(data);
    Object.assign(this, data);
  }
}

export class MobiSimRegistrationDetailEntity extends BasedDetailTransactionResponseModel {}
